import packageJson from "../package.json";

export enum AppEnv {
  Dev = "preview",
  Prod = "runtime",
}

export const defaultResourceAttr = {
  "sdk_version": packageJson.version,
  "sdk_type": "client-backend",
  "sdk_language": "node"
}

export const pointKillTag = "__point_kill_info";


export const TraceDropToken = "TraceDropToken"